module.exports = __webpack_public_path__ + "static/img/pic_qdyw_kcpx@2x.eda7a61e.png";